let imageChangeTimeout; // Variable to store timeout ID

window.onload = function () {
  const URL = window.location.href;
  document.getElementById("copy-button").innerHTML =
    '<a class="btn btn-outline-secondary btn-lg btnClipboardJS" data-clipboard-text="' +
    URL +
    '" id="alertCard"><img src="https://cdn.shopify.com/s/files/1/0532/6041/9223/files/link-share-icon-24w.png?v=1707317930" alt="Clipboard Icon" width="24" height="24"></a>';

  new ClipboardJS(".btnClipboardJS").on("success", function () {
    copiedToClipboard();
  });
};

function copiedToClipboard() {
  // Change the image source directly
  const img = document.querySelector("#alertCard img");
  img.src =
    "https://cdn.shopify.com/s/files/1/0532/6041/9223/files/icons8-check-30.png?v=1707318366";

  // Clear any existing timeout
  clearTimeout(imageChangeTimeout);

  // Set timeout to reset image source after 3 seconds
  imageChangeTimeout = setTimeout(function () {
    img.src =
      "https://cdn.shopify.com/s/files/1/0532/6041/9223/files/link-share-icon-24w.png?v=1707317930";
  }, 3000);
}

function addToCart(selectedSellingPlanID, selectedVariantID) {
  const form = document.querySelector(".shopify-product-form");
  let formData = new FormData(form);
  let stickyQuantityValue = document.querySelector(".quantity-selector__input")?.value; 
  if(!stickyQuantityValue) { stickyQuantityValue = 1 };
  formData.append("id", selectedVariantID);
  formData.append("quantity", stickyQuantityValue);
  formData.append("selling_plan", selectedSellingPlanID);

  const results = Object.fromEntries(formData);
  const payLoad = JSON.stringify(results);

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: payLoad,
  })
    .then((res) => res.json())
    .then(() => {
      console.log(this);
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((err) => console.log(err))
    .finally(() => {
      document.dispatchEvent(new CustomEvent("variant:add"));
      // This event should be triggering the cart icon count in the header but is consistently failing
      // document.dispatchEvent(new CustomEvent("cart:change"))
    });
}

$(document).ready(function () {
  const subscribeAndSaveRadio = document.querySelector(
    'input[value="subscribeAndSave"]'
  );
  const oneTimePurchaseRadio = document.querySelector(
    'input[value="oneTimePurchase"]'
  );

  setTimeout(function () {
    $("#video-banner").contents().unwrap();
  }, 50);

  $(".button--recharge-atc").click(function () {
    if (subscribeAndSaveRadio.checked) {
      event.preventDefault();

      let selectedSubSaveOption = document.querySelector(
        ".toggle-buttons .toggle-button.selected"
      );
      let subSavePlan = parseInt(
        selectedSubSaveOption.getAttribute("data-selling-plan")
      );
      let subSaveProduct = parseInt(
        selectedSubSaveOption.getAttribute("data-product-id")
      );

      console.log("subsave purchase");
      addToCart(subSavePlan, subSaveProduct);
    } else if (oneTimePurchaseRadio.checked) {
      console.log("one time purchase");
    }
  });

  // Custom Recharge Widget by Aessymetric //
  var price = $(
    ".rc-purchase-option[part*=\"rc-purchase-option__selected\"] .rc-price"
  ).text();
  if(!price){
    const buyButtons = document.querySelectorAll('.buy-buttons[data-price]');
    buyButtons.forEach(function (buyButton) {
      let dataPrice = buyButton.getAttribute('data-price');
      if(buyButton.querySelector('.selected-price')){
        price = dataPrice;
      }
    })
  }
  
  var formattedPrice = "" //"--- " + price;
  const sticktAtcPriceformat = parseFloat(price.replace('$', ''));
  $(".selected-price").text(formattedPrice);
  //$(".sticky-atc-price").text(`--- $${Math.floor(sticktAtcPriceformat)}`);


  oneTimePurchaseRadio.addEventListener("change", function () {
    console.log("Clicked One-Time Purchase radio button");
    if (this.checked) {
      $(".toggle-buttons .toggle-button").eq(0).click();

      document.querySelector(".toggle-container").style.display = "none";
      document
        .querySelector(".recharge--subscribeAndSave")
        .classList.remove("active");
      document
        .querySelector(".recharge--oneTimePurchase")
        .classList.add("active");

      var price = $(
        ".rc-purchase-option[part*=\"rc-purchase-option__selected\"] .rc-price"
      ).text();
      var formattedPrice = "" //"--- " + price;
      const sticktAtcPriceformat = parseFloat(price.replace('$', ''));
      $(".selected-price").text(formattedPrice);
      //$(".sticky-atc-price").text(`--- $${Math.floor(sticktAtcPriceformat)}`);

      // Click the corresponding element
      var element = document.querySelector(
        '.rc_widget__option__input--onetime[value="onetime"]'
      );
      if (element) {
        element.click();
      }
    }
    var otpTrifecta = document.querySelector(".otp-trifecta");
    if (otpTrifecta) {
      otpTrifecta.classList.add("hidden-otp-trifecta");
      console.log(".otp-trifecta element hidden (class added)");
    } else {
      console.log(".otp-trifecta element not found");
    }

    var rcTrifecta = document.querySelector(".rc-trifecta");
    if (rcTrifecta) {
      rcTrifecta.innerHTML = "$330.00";
      console.log(".rc-trifecta element hidden (class added)");
    } else {
      console.log(".rc-trifecta element not found");
    }
  });

  subscribeAndSaveRadio.addEventListener("change", function () {
    console.log("Clicked Subscribe & Save radio button");
    if (this.checked) {
      // Display the toggle container
      document.querySelector(".toggle-container").style.display = "flex";

      document
        .querySelector(".recharge--subscribeAndSave")
        .classList.add("active");
      document
        .querySelector(".recharge--oneTimePurchase")
        .classList.remove("active");

      var price = $(
        ".rc-purchase-option[part*=\"rc-purchase-option__selected\"] .rc-price"
      ).text();

      var formattedPrice = "" //"--- " + price;
      const sticktAtcPriceformat = parseFloat(price.replace('$', ''));
      $(".selected-price").text(formattedPrice);
      //$(".sticky-atc-price").text(`--- $${Math.floor(sticktAtcPriceformat)}`);

      // Remove the class to show .otp-trifecta
      var otpTrifecta = document.querySelector(".otp-trifecta");
      if (otpTrifecta) {
        otpTrifecta.classList.remove("hidden-otp-trifecta");
        console.log(".otp-trifecta element displayed (class removed)");
      } else {
        console.log(".otp-trifecta element not found");
      }

      var rcTrifecta = document.querySelector(".rc-trifecta");
      if (rcTrifecta) {
        rcTrifecta.innerHTML = "$264.00";
        console.log(".rc-trifecta element hidden (class added)");
      } else {
        console.log(".rc-trifecta element not found");
      }

      // Click the corresponding element
      var element = document.querySelector(
        '.rc_widget__option__input--subsave[value="subsave"]'
      );
      if (element) {
        element.click();
      }

      function checkOptionCount() {
        var selectElement = document.querySelector(
          ".rc_widget__option__plans__dropdown"
        ); // corrected class selector
        if (selectElement) {
          var optionCount = selectElement.options.length;

          if (optionCount <= 2) {
            setTimeout(() => {
              if (optionCount === 1) {
                document.getElementById("toggle45").style.display = "none";
                document
                  .querySelectorAll(".toggle-buttons")
                  .forEach((element) => {
                    element.classList.add("justify-center-content");
                  });
              } else {
                document.getElementById("toggle45").style.display = "block";
              }
            }, 100);
          }
        }
      }

      setTimeout(() => {
        checkOptionCount();
      }, 100);
    }
  });


  $(".toggle-buttons .toggle-button").on("click", function () {
    var value = $(this).attr("data-value");
    $(".toggle-buttons .toggle-button").removeClass("selected");
    $(this).addClass("selected");

    if (document.querySelector("[data-plan-option]")) {
      document.querySelector('[data-plan-option="' + value + '"]').click();
      var toggleDays = $('[data-plan-option="' + value + '"]').val();
      document.querySelector(".rc_widget__option__plans__dropdown").value =
        toggleDays;
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  if (body && body.id === "premium-skincare-by-dr-amir-karam-karammd-skin") {
    if (window.innerWidth <= 1024) {
      const videoDiv = document.getElementById("video-full-width");
      const section = document.querySelector(".section");

      if (videoDiv && section) {
        section.parentNode.insertBefore(videoDiv, section);
      }
    }
  }
});

// On cart page load, if main subscription is gone, remove associated gifts
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.indexOf('/cart') === 0) {
    setTimeout(function() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          // only remove gifts and reload if gifts are still present
          var giftIds = [46771140100341, 46658585985269];
          var hasGifts = cart.items.some(function(item) {
            return giftIds.indexOf(item.id) !== -1;
          });
          var hasMain = cart.items.some(function(item) {
            return item.id === 44157322625269 &&
            (item.selling_plan_allocation?.selling_plan?.id === 3869540597 || item.selling_plan_allocation?.selling_plan?.id === 3869573365);
          });
          console.log("hasGifts",hasGifts);
          console.log("hasMain",hasMain);
          // if (!hasMain && hasGifts) {
          //   fetch('/cart/update.js', {
          //     method: 'POST',
          //     headers: { 'Content-Type': 'application/json' },
          //     body: JSON.stringify({
          //       updates: {
          //         46771140100341: 0,
          //         46658585985269: 0
          //       }
          //     })
          //   }).then(function() {
          //     // reload page once to show updated cart
          //     window.location.reload();
          //   });
          // }
        });
    }, 250);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  let videoSlide = document.querySelector('.product__media-item--video');
  let slider = document.querySelector('.product__media-slider');

  if (videoSlide && slider) {
    videoSlide.addEventListener('click', function () {
      // Ensure the slider can still be navigated
      setTimeout(() => {
        slider.classList.remove('swiper-disabled');
      }, 500);
    });
  }
});

(function () {
  const EMAIL_NAME_RECIPIENT = 'recipient-email';
  const EMAIL_NAME_SENDER = 'giver-email';
  const PROCESSED_ATTR = 'data-email-guard';
  const ERROR_CLASS = 'email-guard-error';

  function normalizeEmail(s) {
    return (s || '').trim().toLowerCase();
  }

  function createErrorNode(msg) {
    const div = document.createElement('div');
    div.className = ERROR_CLASS;
    div.setAttribute('role', 'alert');
    div.setAttribute('aria-live', 'assertive');
    div.style.color = ' #b00020';
    div.style.marginTop = '6px';
    div.style.fontSize = '0.95em';
    div.textContent = msg;
    return div;
  }

  function showError(form, targetInput, text) {
    const prev = form.querySelector('.' + ERROR_CLASS);
    if (prev) prev.remove();

    const err = createErrorNode(text);

    if (targetInput && targetInput.parentNode) {
      const parent = targetInput.parentNode;
      parent.parentNode.insertBefore(err, parent.nextSibling);
    } else {
      form.insertBefore(err, form.firstChild);
    }

    try { targetInput && targetInput.focus(); } catch (e) {}
  }

  function clearError(form) {
    const prev = form.querySelector('.' + ERROR_CLASS);
    if (prev) prev.remove();
  }

  function shouldBlockSubmission(form) {
    const recipient = form.querySelector(`.${EMAIL_NAME_RECIPIENT} input`);
    const sender = form.querySelector(`.${EMAIL_NAME_SENDER} input`);
    if (!recipient || !sender) return {block: false};

    const r = normalizeEmail(recipient.value);
    const s = normalizeEmail(sender.value);
    if (!r || !s) return {block: false};
    return {block: r === s, recipientInput: recipient, senderInput: sender};
  }

  function attachGuardToForm(form) {
    if (!form || form.hasAttribute(PROCESSED_ATTR)) return;
    form.setAttribute(PROCESSED_ATTR, '1');

    form.addEventListener('submit', function (ev) {
      const res = shouldBlockSubmission(form);
      if (res.block) {
        ev.preventDefault();
        ev.stopImmediatePropagation && ev.stopImmediatePropagation();
        showError(form, res.senderInput || res.recipientInput,
                  'Sender email must be different from recipient email.');
        return false;
      }
      clearError(form);
    }, true);

    form.addEventListener('click', function (ev) {
      const target = ev.target;
      if (!target) return;
      const isSubmitButton = target.classList.contains("wizard__submit");
      if (!isSubmitButton) return;

      const res = shouldBlockSubmission(form);
      if (res.block) {
        ev.preventDefault();
        ev.stopImmediatePropagation && ev.stopImmediatePropagation();
        showError(form, res.senderInput || res.recipientInput,
                  'Sender email must be different from recipient email.');
        return false;
      }
      clearError(form);
    }, true);
  }

  function scanAndAttach() {
    const selector = `.gift-of-great-skin form`;

    try {
      const forms = document.querySelectorAll(selector);
      forms.forEach(attachGuardToForm);
      return;
    } catch (e) {
      console.log(e.message);
    }

  }

  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      scanAndAttach();
    }
  });

  mo.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  const videos = document.querySelectorAll("video.lazy-video");

  // Fallback if IntersectionObserver isn't supported
  if (!("IntersectionObserver" in window)) {
    videos.forEach(v => {
      v.src = v.dataset.src;
      v.load();
      v.play?.().catch(() => {});
    });
    return;
  }

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const v = entry.target;
      const src = v.dataset.src;
      if (src && !v.src) {
        v.src = src;
        v.load();
        // Autoplay will usually work since it's muted, but guard anyway.
        v.play().catch(() => {});
      }

      obs.unobserve(v);
    });
  }, {
    root: null,
    rootMargin: "200px 0px", // start loading a bit before it enters view
    threshold: 0.01
  });

  videos.forEach(v => io.observe(v));
})();